export const nameLength = 16;

export type Teacher = {
  id: string;
  fullName: string;
  firstName: string;
  lastName: string;
};
